import { faBell } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { toggleNotificationSliderVisibility } from "notification/tools/common"
import React from "react"
import { connect } from "react-redux"

interface INotificationSliderIconProps {
  isOpened: boolean
}

export const NotificationSliderIconFn = React.memo(
  ({ isOpened }: INotificationSliderIconProps): JSX.Element => (
    <Tooltip
      placement="top"
      title={translate(isOpened ? "notification.hide" : "notification.display")}
      sx={{ "& .icon": { cursor: "pointer" } }}>
      <span id="notification-slider" onClick={() => toggleNotificationSliderVisibility()}>
        <FontAwesomeIcon icon={faBell} size="2x" className="icon notification-slider-icon" />
      </span>
    </Tooltip>
  )
)

export const NotificationSliderIcon = connect(
  (state: IRootState): INotificationSliderIconProps => ({
    isOpened: state.notification.isSliderOpened
  })
)(NotificationSliderIconFn)
